import { render, staticRenderFns } from "./AddDaobitPrice.vue?vue&type=template&id=148dc83e"
import script from "./AddDaobitPrice.vue?vue&type=script&lang=js"
export * from "./AddDaobitPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports